// https://medaitalk.atlassian.net/wiki/spaces/VNA/pages/554631174/Permisssion+Matrix

export const PERMISSIONS = Object.freeze({
  page: {
    admin_settings: 'admin_settings',
    user_settings: 'user_settings',
    view_dashboard: 'view_dashboard',
    view_order: 'view_order',
    view_report: 'view_report',
    view_sharedlist: 'view_sharedlist',
    view_studylist: 'view_studylist',
    view_worklist: 'view_worklist',
    view_assignedlist: 'view_assignedlist',
    view_viewer: 'view_viewer',
    view_patient: 'view_patient',
    view_upload: 'view_upload',
  },
  layout: {
    share: 'layout.share',
  },
  template: {
    share: 'template.share',
  },
  order: {
    create: 'order.create',
    share: 'order.share',
    update: 'order.update',
    delete: 'order.delete',
    assign: 'order.assign',
  },
  report: {
    create: 'report.create',
    approved: 'report.approved',
    update: 'report.update',
    print: 'report.print',
    capture: 'report.capturevideo',
    keyimage: 'report.keyimage',
  },
  studylist: {
    delete: 'studylist.delete',
    export: 'studylist.export',
    match: 'studylist.match',
    note: 'studylist.note',
    report: 'studylist.report',
    share: 'studylist.share',
    upload: 'studylist.upload',
    attachment_add: 'studylist.attachment.add',
  },
  worklist: {
    share: 'worklist.share',
    report: 'worklist.report',
    attachment: 'worklist.attachment',
    hisorderlist: 'worklist.hisorderlist',
  },
  assigned: {
    admin_assignedlist: 'admin_assignedlist',
  },
  dashboard: {
    admin_dashboard: 'admin_dashboard',
  },
  viewer: {
    keyimage: 'viewer.keyimage',
    delete_study: 'viewer.deletestudy',
    download: 'viewer.download',
    record_annotation: 'viewer.recordannotation',
  },
  patient: {
    add: 'patient.add',
    update: 'patient.update',
    delete: 'patient.delete',
    resetpassword: 'patient.resetpassword',
  },
});

export enum ROLES {
  Administrator = 'vindr-administrator',
  Radiologist = 'vindr-radiologist',
  Technologist = 'vindr-technologist',
  Moderator = 'vindr-moderator',
  Patient = 'vindr-patient',
}
